/**
 * Forms Layout Route
 * Layout route for the /forms surface. Renders an Outlet for child routes
 * so future additions (e.g. /forms/$formId preview) don't have to fight
 * the index route's component.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

const FormsLayoutComponent = () => {
  return <Outlet />;
};

export const Route = createFileRoute('/_authenticated/forms')({
  component: FormsLayoutComponent,
});
